import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/config';
import { collection, doc, getDoc, setDoc, query, getDocs } from 'firebase/firestore';

// Valores padrão
const DEFAULT_SIMPLES = ['CMT AUX', 'GRÊMIOS E EQUIPES', 'UIS', 'MISSÃO', 'PROVA', 'SERVIÇO', 'OUTROS INTERNO'];
const DEFAULT_COMPLEXOS = ['OUTROS FORA', 'RESTRIÇÃO', 'NÚPCIAS', 'LUTO', 'LTS', 'CONVALESCENÇA MÉDICA', 'DESLIGAMENTO', 'DISPENSA SERVIÇO', 'DOAÇÃO DE SANGUE', 'DISTRITO POLICIAL', 'FÓRUM', 'ESTÁGIO', 'GTDS', 'VISITA', 'CAPS CRPM', 'LICENÇA COMP', 'LICENÇA PAT/MATERNIDADE', 'CODONT CONSULTAS', 'HPM INTERNAÇÃO'];

const LiderEOConfig = () => {
  // --- ESTADOS GERAIS ---
  const [activeTab, setActiveTab] = useState('revistas'); 
  const [loading, setLoading] = useState(false);

  // --- ESTADOS REVISTAS ---
  const [turmasList, setTurmasList] = useState([]);
  const [selectedTurma, setSelectedTurma] = useState(null);
  const [revistas, setRevistas] = useState([]);
  const [loadingTurmas, setLoadingTurmas] = useState(true);
  const [novoHorario, setNovoHorario] = useState('');
  const [novoNome, setNovoNome] = useState('');

  // --- ESTADOS DESTINOS ---
  const [destinosSimples, setDestinosSimples] = useState([]);
  const [destinosComplexos, setDestinosComplexos] = useState([]);
  const [novoDestinoSimples, setNovoDestinoSimples] = useState('');
  const [novoDestinoComplexo, setNovoDestinoComplexo] = useState('');

  // --- ESTADOS GRÊMIOS E EQUIPES ---
  const [gremios, setGremios] = useState([]);
  const [equipes, setEquipes] = useState([]);
  const [novoGremio, setNovoGremio] = useState('');
  const [novaEquipe, setNovaEquipe] = useState('');

  // --- CAMINHOS ---
  const TURMAS_PATH = ['artifacts', 'app-estagios', 'public', 'data', 'turmas'];
  const CONFIG_REVISTAS_PATH = ['artifacts', 'app-estagios', 'public', 'data', 'revistas_config'];
  const CONFIG_DESTINOS_PATH = ['artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'destinos_opcoes'];
  const CONFIG_GREMIOS_PATH = ['artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'gremios_opcoes'];

  // 1. CARREGAMENTO INICIAL (TURMAS)
  useEffect(() => {
    const fetchTurmas = async () => {
      setLoadingTurmas(true);
      try {
        const turmasRef = collection(db, ...TURMAS_PATH);
        const q = query(turmasRef);
        const querySnapshot = await getDocs(q);
        const lista = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return { id: doc.id, nome: data.nome || data.turma || doc.id };
        });
        lista.sort((a, b) => a.nome.localeCompare(b.nome));
        setTurmasList(lista);
        if (lista.length > 0) setSelectedTurma(lista[0]);
      } catch (error) { console.error("Erro turmas:", error); } 
      finally { setLoadingTurmas(false); }
    };
    fetchTurmas();
  }, []);

  // 2. CARREGA DESTINOS
  useEffect(() => {
    if (activeTab === 'destinos') {
        const fetchDestinos = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, ...CONFIG_DESTINOS_PATH);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setDestinosSimples(data.simples || DEFAULT_SIMPLES);
                    setDestinosComplexos(data.complexos || DEFAULT_COMPLEXOS);
                } else {
                    setDestinosSimples(DEFAULT_SIMPLES);
                    setDestinosComplexos(DEFAULT_COMPLEXOS);
                }
            } catch (error) { console.error("Erro destinos:", error); }
            setLoading(false);
        };
        fetchDestinos();
    }
  }, [activeTab]);

  // 3. CARREGA REVISTAS
  useEffect(() => {
    if (!selectedTurma || activeTab !== 'revistas') return;
    const loadConfigRevistas = async () => {
      setLoading(true);
      setRevistas([]); 
      try {
        const docRef = doc(db, ...CONFIG_REVISTAS_PATH, selectedTurma.id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setRevistas(data.revistas || []);
        }
      } catch (error) { console.error(error); }
      setLoading(false);
    };
    loadConfigRevistas();
  }, [selectedTurma, activeTab]);

  // 4. CARREGA GRÊMIOS E EQUIPES
  useEffect(() => {
    if (activeTab === 'gremios') {
        const fetchGremiosEquipes = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, ...CONFIG_GREMIOS_PATH);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setGremios(data.gremios || []);
                    setEquipes(data.equipes || []);
                } else {
                    setGremios([]);
                    setEquipes([]);
                }
            } catch (error) { console.error("Erro gremios/equipes:", error); }
            setLoading(false);
        };
        fetchGremiosEquipes();
    }
  }, [activeTab]);

  // --- FUNÇÕES DE SALVAR NO FIRESTORE ---
  const saveRevistas = async (novaLista) => {
    if (!selectedTurma) return;
    try {
      await setDoc(doc(db, ...CONFIG_REVISTAS_PATH, selectedTurma.id), {
        turmaId: selectedTurma.id, turmaNome: selectedTurma.nome, revistas: novaLista, updatedAt: new Date()
      });
    } catch (error) { alert(error.message); }
  };

  const saveDestinos = async (novosSimples, novosComplexos) => {
      try {
        await setDoc(doc(db, ...CONFIG_DESTINOS_PATH), {
            simples: novosSimples, complexos: novosComplexos, updatedAt: new Date()
        });
      } catch (error) { alert('Erro ao salvar destinos.'); }
  };

  const saveGremiosEquipes = async (novosGremios, novasEquipes) => {
      try {
        await setDoc(doc(db, ...CONFIG_GREMIOS_PATH), {
            gremios: novosGremios,
            equipes: novasEquipes,
            updatedAt: new Date()
        });
      } catch (error) { alert('Erro ao salvar configurações.'); }
  };

  // --- HANDLERS REVISTAS ---
  // ... (mesmo código anterior)
  const handleAddRevista = async () => {
    if (!novoHorario || !novoNome) return alert('Preencha tudo');
    const novaLista = [...revistas, { id: Date.now().toString(), horario: novoHorario, nome: novoNome }].sort((a,b)=>a.horario.localeCompare(b.horario));
    setRevistas(novaLista); setNovoHorario(''); setNovoNome('');
    await saveRevistas(novaLista);
  };
  const handleRemoveRevista = async (id) => {
    if(!window.confirm("Excluir?")) return;
    const novaLista = revistas.filter(r => r.id !== id);
    setRevistas(novaLista);
    await saveRevistas(novaLista);
  };

  // --- HANDLERS DESTINOS ---
  // ... (mesmo código anterior)
  const handleAddDestinoSimples = async () => {
      if (!novoDestinoSimples) return;
      if (destinosSimples.includes(novoDestinoSimples.toUpperCase())) return alert('Já existe.');
      const updated = [...destinosSimples, novoDestinoSimples.toUpperCase()].sort();
      setDestinosSimples(updated); setNovoDestinoSimples('');
      await saveDestinos(updated, destinosComplexos);
  };
  const handleRemoveDestinoSimples = async (item) => {
      if(!window.confirm(`Remover "${item}"?`)) return;
      const updated = destinosSimples.filter(i => i !== item);
      setDestinosSimples(updated); await saveDestinos(updated, destinosComplexos);
  };
  const handleAddDestinoComplexo = async () => {
      if (!novoDestinoComplexo) return;
      if (destinosComplexos.includes(novoDestinoComplexo.toUpperCase())) return alert('Já existe.');
      const updated = [...destinosComplexos, novoDestinoComplexo.toUpperCase()].sort();
      setDestinosComplexos(updated); setNovoDestinoComplexo('');
      await saveDestinos(destinosSimples, updated);
  };
  const handleRemoveDestinoComplexo = async (item) => {
      if(!window.confirm(`Remover "${item}"?`)) return;
      const updated = destinosComplexos.filter(i => i !== item);
      setDestinosComplexos(updated); await saveDestinos(destinosSimples, updated);
  };

  // --- HANDLERS GRÊMIOS E EQUIPES ---
  const handleAddGremio = async () => {
      if (!novoGremio) return;
      if (gremios.includes(novoGremio.toUpperCase())) return alert('Já existe.');
      const updated = [...gremios, novoGremio.toUpperCase()].sort();
      setGremios(updated); setNovoGremio('');
      await saveGremiosEquipes(updated, equipes);
  };
  const handleRemoveGremio = async (item) => {
      if(!window.confirm(`Remover "${item}"?`)) return;
      const updated = gremios.filter(i => i !== item);
      setGremios(updated); await saveGremiosEquipes(updated, equipes);
  };

  const handleAddEquipe = async () => {
      if (!novaEquipe) return;
      if (equipes.includes(novaEquipe.toUpperCase())) return alert('Já existe.');
      const updated = [...equipes, novaEquipe.toUpperCase()].sort();
      setEquipes(updated); setNovaEquipe('');
      await saveGremiosEquipes(gremios, updated);
  };
  const handleRemoveEquipe = async (item) => {
      if(!window.confirm(`Remover "${item}"?`)) return;
      const updated = equipes.filter(i => i !== item);
      setEquipes(updated); await saveGremiosEquipes(gremios, updated);
  };

  return (
    // CONTAINER DE PÁGINA COMPLETA (Fundo Cinza, Largura Total)
    <div style={{ padding: '24px', backgroundColor: '#f7fafc', minHeight: '100vh', width: '100%', boxSizing: 'border-box' }}>
      
      {/* HEADER */}
      <div style={{ marginBottom: '24px' }}>
          <h2 style={{ color: '#1a202c', margin: 0, fontSize: '26px' }}>Configurações Resultado Online</h2>
      </div>

      {/* CONTAINER BRANCO (Cartão Principal - Largura 100%) */}
      <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', width: '100%', boxSizing: 'border-box' }}>
          
          {/* ABAS */}
          <div style={{ display: 'flex', gap: '24px', borderBottom: '2px solid #e2e8f0', marginBottom: '24px', flexWrap: 'wrap' }}>
            <button onClick={() => setActiveTab('revistas')} style={{ padding: '12px 0', background: 'none', border: 'none', borderBottom: activeTab === 'revistas' ? '3px solid #3182ce' : '3px solid transparent', color: activeTab === 'revistas' ? '#3182ce' : '#718096', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px' }}>
                🕒 HORÁRIOS & REVISTAS
            </button>
            <button onClick={() => setActiveTab('destinos')} style={{ padding: '12px 0', background: 'none', border: 'none', borderBottom: activeTab === 'destinos' ? '3px solid #805ad5' : '3px solid transparent', color: activeTab === 'destinos' ? '#805ad5' : '#718096', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px' }}>
                📋 TIPOS DE AFASTAMENTO
            </button>
            <button onClick={() => setActiveTab('gremios')} style={{ padding: '12px 0', background: 'none', border: 'none', borderBottom: activeTab === 'gremios' ? '3px solid #38a169' : '3px solid transparent', color: activeTab === 'gremios' ? '#38a169' : '#718096', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px' }}>
                🏅 GRÊMIOS E EQUIPES
            </button>
          </div>

          {/* CONTEÚDO REVISTAS */}
          {activeTab === 'revistas' && (
            <div style={{ animation: 'fadeIn 0.3s' }}>
                <p style={{ fontSize: '13px', color: '#718096', marginBottom: '16px' }}>* Configurações individuais por turma.</p>
                
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '12px', marginBottom: '12px' }}>
                    {loadingTurmas && <span>Carregando turmas...</span>}
                    {turmasList.map(turma => (
                        <button key={turma.id} onClick={() => setSelectedTurma(turma)}
                            style={{ padding: '8px 16px', borderRadius: '20px', border: selectedTurma?.id === turma.id ? '1px solid #3182ce' : '1px solid #e2e8f0', backgroundColor: selectedTurma?.id === turma.id ? '#ebf8ff' : '#fff', color: selectedTurma?.id === turma.id ? '#2c5282' : '#718096', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            {turma.nome}
                        </button>
                    ))}
                </div>

                {selectedTurma ? (
                    <>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', backgroundColor: '#f7fafc', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                            <div><label style={{fontSize:'11px', fontWeight:'bold', color:'#718096'}}>HORÁRIO</label><input type="time" value={novoHorario} onChange={e=>setNovoHorario(e.target.value)} style={{display:'block', padding:'8px', borderRadius:'6px', border:'1px solid #cbd5e0'}}/></div>
                            <div style={{flex:1}}><label style={{fontSize:'11px', fontWeight:'bold', color:'#718096'}}>NOME</label><input type="text" placeholder="Ex: Matinal" value={novoNome} onChange={e=>setNovoNome(e.target.value)} style={{display:'block', width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #cbd5e0'}}/></div>
                            <button onClick={handleAddRevista} style={{padding:'9px 20px', backgroundColor:'#3182ce', color:'white', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer'}}>Adicionar</button>
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead><tr style={{textAlign:'left', background:'#edf2f7', color:'#4a5568', fontSize:'12px'}}><th style={{padding:'12px'}}>HORÁRIO</th><th style={{padding:'12px'}}>NOME</th><th style={{padding:'12px', textAlign:'right'}}>AÇÃO</th></tr></thead>
                            <tbody>
                                {revistas.map(r => (
                                    <tr key={r.id} style={{borderBottom:'1px solid #edf2f7'}}>
                                        <td style={{padding:'12px', fontWeight:'bold'}}>{r.horario}</td><td style={{padding:'12px'}}>{r.nome}</td>
                                        <td style={{padding:'12px', textAlign:'right'}}><button onClick={()=>handleRemoveRevista(r.id)} style={{color:'#e53e3e', background:'none', border:'none', cursor:'pointer', fontWeight:'bold'}}>Excluir</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                ) : <div style={{padding:'40px', textAlign:'center', color:'#a0aec0'}}>Selecione uma turma.</div>}
            </div>
          )}

          {/* CONTEÚDO DESTINOS */}
          {activeTab === 'destinos' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px', animation: 'fadeIn 0.3s' }}>
                {[
                    { title: 'Simples (Só Nome)', list: destinosSimples, val: novoDestinoSimples, setVal: setNovoDestinoSimples, add: handleAddDestinoSimples, rem: handleRemoveDestinoSimples, color: '#3182ce' },
                    { title: 'Detalhados (QRU, Endereço...)', list: destinosComplexos, val: novoDestinoComplexo, setVal: setNovoDestinoComplexo, add: handleAddDestinoComplexo, rem: handleRemoveDestinoComplexo, color: '#e53e3e' }
                ].map((grp, idx) => (
                    <div key={idx} style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', display: 'flex', flexDirection: 'column' }}>
                        <h3 style={{ marginTop: 0, color: grp.color, fontSize: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>{grp.title}</h3>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                            <input placeholder="Novo destino..." value={grp.val} onChange={e => grp.setVal(e.target.value)} style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
                            <button onClick={grp.add} style={{ backgroundColor: grp.color, color: 'white', border: 'none', borderRadius: '6px', width: '40px', cursor: 'pointer', fontSize:'18px' }}>+</button>
                        </div>
                        <div style={{ flex: 1, maxHeight: '400px', overflowY: 'auto' }}>
                            {grp.list.map(item => (
                                <div key={item} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', borderBottom: '1px solid #f7fafc', alignItems:'center' }}>
                                    <span style={{color: '#2d3748'}}>{item}</span>
                                    <button onClick={() => grp.rem(item)} style={{ border: 'none', background: 'none', color: '#e53e3e', cursor: 'pointer', fontSize:'18px', fontWeight:'bold' }}>×</button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
          )}

          {/* CONTEÚDO GRÊMIOS E EQUIPES (NOVA ABA DIVIDIDA) */}
          {activeTab === 'gremios' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px', animation: 'fadeIn 0.3s' }}>
                
                {/* COLUNA: GRÊMIOS */}
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ marginTop: 0, color: '#38a169', fontSize: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Grêmios</h3>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                        <input placeholder="Ex: Grêmio de Cavalaria..." value={novoGremio} onChange={e => setNovoGremio(e.target.value)} style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
                        <button onClick={handleAddGremio} style={{ backgroundColor: '#38a169', color: 'white', border: 'none', borderRadius: '6px', width: '40px', cursor: 'pointer', fontSize:'18px' }}>+</button>
                    </div>
                    <div style={{ flex: 1, maxHeight: '400px', overflowY: 'auto' }}>
                        {gremios.length === 0 && <span style={{ color: '#a0aec0', fontSize: '13px' }}>Nenhum grêmio cadastrado.</span>}
                        {gremios.map(item => (
                            <div key={item} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', borderBottom: '1px solid #f7fafc', alignItems:'center' }}>
                                <span style={{color: '#2d3748'}}>{item}</span>
                                <button onClick={() => handleRemoveGremio(item)} style={{ border: 'none', background: 'none', color: '#e53e3e', cursor: 'pointer', fontSize:'18px', fontWeight:'bold' }}>×</button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* COLUNA: EQUIPES */}
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ marginTop: 0, color: '#dd6b20', fontSize: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Equipes</h3>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                        <input placeholder="Ex: Equipe de Futebol..." value={novaEquipe} onChange={e => setNovaEquipe(e.target.value)} style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
                        <button onClick={handleAddEquipe} style={{ backgroundColor: '#dd6b20', color: 'white', border: 'none', borderRadius: '6px', width: '40px', cursor: 'pointer', fontSize:'18px' }}>+</button>
                    </div>
                    <div style={{ flex: 1, maxHeight: '400px', overflowY: 'auto' }}>
                        {equipes.length === 0 && <span style={{ color: '#a0aec0', fontSize: '13px' }}>Nenhuma equipe cadastrada.</span>}
                        {equipes.map(item => (
                            <div key={item} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', borderBottom: '1px solid #f7fafc', alignItems:'center' }}>
                                <span style={{color: '#2d3748'}}>{item}</span>
                                <button onClick={() => handleRemoveEquipe(item)} style={{ border: 'none', background: 'none', color: '#e53e3e', cursor: 'pointer', fontSize:'18px', fontWeight:'bold' }}>×</button>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
          )}

      </div>
    </div>
  );
};

export default LiderEOConfig;